import { AjaxService, internalMessageBus, EventsManager, Cookies } from "../../externals";
import { delay, getClock, makeTokenRequest } from "../../helpers";
import { WalletRequestService } from "../RequestService";
import { TokenHandler, TokenProcessingGateway, RequestGateway, TokenStream, LogoutSubscription, TokenLoginSubscription, TokenReader, CookiesStorage, RenewErrorHandler } from "../../common";
import { PlatformJwtManager } from "../../PlatformJwtManager";
export const walletAuthContextFactory = (config) => {
    const tokenReader = new TokenReader(config.siteID, getClock(config.timeControl, config.initialTime));
    const tokenStorage = new CookiesStorage(tokenReader, Cookies);
    const gateway = getGateway(config, tokenStorage, tokenReader);
    const platformJwtManager = new PlatformJwtManager(tokenStorage, config.userInfo, tokenReader, gateway);
    return {
        Gateway: gateway,
        PlatformJwtManager: platformJwtManager,
        Subscriptions: getSubscriptions(gateway, tokenStorage, tokenReader, config)
    };
};
const getGateway = (config, storage, tokenReader) => {
    const service = new WalletRequestService(config.apiUrl, new AjaxService(), config.domainID, makeTokenRequest);
    const tokenHandler = new TokenHandler(storage, internalMessageBus);
    const errorHandler = new RenewErrorHandler(config.userInfo, new EventsManager());
    const tokenStream = new TokenStream(service, tokenHandler, tokenReader, errorHandler);
    const tokenProcessingGateway = new TokenProcessingGateway(tokenStream);
    return new RequestGateway(service, tokenProcessingGateway, storage, tokenReader, delay);
};
const getSubscriptions = (gateway, storage, tokenReader, config) => [
    new LogoutSubscription(config.userInfo, gateway, tokenReader),
    new TokenLoginSubscription(config.userInfo, gateway, storage, tokenReader, legacyWalletTokenLogin)
];
export const legacyWalletTokenLogin = (userInfo, result) => userInfo.legacyWalletTokenLogin(result);
//# sourceMappingURL=WalletAuthContextFactory.js.map